import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Brikk } from 'components/Brikk';
import { SearchInput } from 'components/form-elements/inputs/SearchInput';
import { Text } from 'components/typography';
import { PageLoader } from 'components/loaders/PageLoader';
import { useGetTimeProfiles } from 'services/2n/time-profiles';
import { useModal } from 'store/modals';
import styles from '../styles.module.scss';
import { useAccessManagement2NModal } from '../AccessManagement2NModalContext/useAccessManagement2NModal';
import { ManualScrollToTop } from '../../../../../../../ManualScrollToTop';
import { TimeProfile } from './components/TimeProfile';

export const TimeProfiles = () => {

  const timeProfilesListRef = React.useRef(null);
  const modal = useModal();
  const [keyword, setKeyword] = useState('');
  const { timeProfiles, isLoading } = useGetTimeProfiles();
  const intl = useIntl();
  const accessManagement2NModal = useAccessManagement2NModal();

  const filteredTimeProfiles = !keyword ? timeProfiles : timeProfiles.filter(
    timeProfile => String((timeProfile && (timeProfile.Name || timeProfile.name)) || '').toLowerCase().includes(keyword.toLowerCase()),
  );
  
  if (isLoading) return <PageLoader />;
  
  return (
    <div className={styles.timeProfilesContainer}>
      <Brikk.Heading
        heading="timeProfiles"
      />
      <div 
        className={styles.timeProfilesList}
        ref={timeProfilesListRef}
      >
        <SearchInput
          placeholder={intl.formatMessage({ id: 'search' })}
          keyword={keyword}
          setKeyword={setKeyword}
        />

        {!isLoading && filteredTimeProfiles && filteredTimeProfiles.length > 0 && (
          filteredTimeProfiles.map((timeProfile, index) => (
            <TimeProfile
              key={(timeProfile && (timeProfile.Id || timeProfile.id)) || index}
              timeProfile={timeProfile}
            />
          ))
        )}
        {!isLoading && (!filteredTimeProfiles || filteredTimeProfiles.length === 0) && (
          <Text
            secondary
            center
            intl="noTimeProfilesToDisplay"
            size={16}
          />
        )}
      </div>

      <ManualScrollToTop elementRef={timeProfilesListRef} />

      <div className={styles.formActions}>
        <div className={styles.actionContainer}>

          <Button
            primary
            disabled={accessManagement2NModal.isAdding.timeProfile}
            onClick={() => {
              if (accessManagement2NModal.hasUnsavedChanges.timeProfile) {
                modal.openModal({
                  modalType: 'ConfirmationModal',
                  modalProps: {
                    type: 'error',
                    title: intl.formatMessage({
                      id: 'unsavedChanges',
                    }),
                    content: intl.formatMessage({
                      id: 'unsavedChangesDescription',
                    }),
                    confirmLabel: intl.formatMessage({
                      id: 'discard',
                    }),
                    cancelLabel: intl.formatMessage({
                      id: 'stay',
                    }),
                    onConfirm: () => {
                      modal.closeModal();
                      accessManagement2NModal.setHasUnsavedChanges('timeProfile', false);
                      accessManagement2NModal.updateSelected('timeProfile', null);
                      accessManagement2NModal.updateAdding('timeProfile', true);
                    },
                  },
                });
              } else {
                accessManagement2NModal.updateSelected('timeProfile', null);
                accessManagement2NModal.updateAdding('timeProfile', true);
              }
            }} 
          >
            {intl.formatMessage({ id: 'addNewTimeProfile' })}
          </Button>
        </div>
      </div>
    </div>
  );
};
